export default __webpack_public_path__ + "static/media/BA.7fe38299.svg";